import React, { Component } from 'react'

import './loading.scss'

class Loading extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="loading">
					<div className="lds-dual-ring"></div>
					<p>{this.props.children ? this.props.children : 'Cargando...'}</p>
				</div>
			</React.Fragment>
		)
	}
}

export default Loading
